//#region IMPORT
import { Button } from '../../../../Components/MUIs';
import { Box, Stack, Typography } from '@mui/material';
import DocumentViewer from '../../../../Components/Ui/DocumentViewer';
//#endregion

function M_TBG_CUSTOM_04(props) {
  const fileUrl = props.fullUrl;
  const ext = props.getExtensionFromUrl(fileUrl);

  const isImage = ['jpg', 'jpeg', 'png'].includes(ext);
  const isPdf = ext === 'pdf';

  const renderViewer = () => {
    if (!fileUrl) {
      return (
        <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
          교육 자료가 없습니다.
        </Typography>
      );
    }

    if (isImage) {
      return (
        <img
          src={fileUrl}
          alt="교육자료 이미지"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '70vh',
            objectFit: 'contain',
          }}
        />
      );
    }

    if (isPdf) {
      return (
        <DocumentViewer
          fileUrl={fileUrl}
          renderPreview={props.renderPreview}
          loading={props.loading}
          onDocumentLoadSuccess={props.onDocumentLoadSuccess}
          pageNumber={props.pageNumber}
          pageWidth={props.pageWidth}
          pageViewHeight={props.pageViewHeight}
          setPageViewHeight={props.setPageViewHeight}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      );
    }

    return (
      <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
        미리보기를 지원하지 않는 파일 형식입니다.
      </Typography>
    );
  };

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          작업계획서
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          파일 자료를 통해 작업계획서를 확인해주세요.
        </Typography>
      </Stack>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          overflow: 'hidden',
        }}
      >
        {renderViewer()}

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ p: 2, width: '100%' }}
        >
          <Button
            sx={{ width: '100%', height: '36px', borderRadius: '18px' }}
            name="이전"
            onClick={props.goToPrevPage}
          />
          <Typography
            sx={{
              fontWeight: 'bold',
              mx: 6,
              whiteSpace: 'nowrap',
            }}
          >
            {fileUrl && props.numPages > 0
              ? `${props.pageNumber} / ${props.numPages}`
              : null}
          </Typography>
          <Button
            sx={{ width: '100%', height: '36px', borderRadius: '18px' }}
            name={
              props.pageNumber === props.numPages || !props.pdfFile
                ? '완료'
                : '다음'
            }
            onClick={() => {
              if (props.numPages > 0 && props.pageNumber < props.numPages) {
                props.goToNextPage();
                return;
              }

              props.setActiveStep(props.activeStep + 1);
            }}
          />
        </Stack>
      </Box>
    </>
  );
}

export default M_TBG_CUSTOM_04;
